import { useNitroStore } from "../../../store/Store";
import { useIsMobile } from "../../../hooks/useIsMobile";
import NitroMap from "../../../components/map";

const Map = ({ searchDisabled }: { searchDisabled: boolean }) => {
  const isMobile = useIsMobile(768);
  const [locations] = useNitroStore((states) => [states.locations]);

  const shouldHidePins = searchDisabled && !isMobile;

  const locationsToShow = shouldHidePins ? [] : locations;

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
      }}
    >
      <NitroMap locations={locationsToShow} />
    </div>
  );
};

export default Map;
